import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

/** July 2025 toolkit */
export const motivationToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.MOTIVATION,
  iFrameSrcUrl: '/motivation',
  micrositeUrl: 'motivation',
  title: {
    id: 'motivationToolkit.title',
    defaultMessage: 'Tapping into motivation',
    description: 'Microsite page title',
  },
  featureFlag: 'isMotivationToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events/understanding-motivations-at-work',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_PROVIDER_BOOKING },
  ],
  page: '202507 motivation',
  trackUTMParams: {
    utm_campaign: 'motivation202507',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'motivation',
  },
  shouldHideForInternational: true,
}
